import {styled} from '@mui/material/styles';

import {ItemsSectionConfig} from 'filters/features/FilterDialog/types';

import {dialogItemsMap} from 'filters/features/FilterDialog/sections/ItemsSection/items';
import {getItemId} from 'filters/features/FilterDialog/utils/internal';

export const createItemsSection = (options: Omit<ItemsSectionConfig, 'type'>): ItemsSectionConfig => {
  return {
    ...options,
    type: 'items' as const,
  };
};

const SRoot = styled('div')(({theme}) => ({
  '&:is(&)': {
    background: 'unset',
  },

  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

const SBlock = styled('div')(({theme}) => ({
  padding: theme.spacing(6),
  background: theme.palette.common.white,
  borderRadius: theme.shape.borderRadiusRegular,
}));

export const ItemsSection = ({id, items}: ItemsSectionConfig) => {
  return (
    <SRoot>
      {items.map(item => {
        if ('Component' in item) {
          const {Component, getActiveFiltersContent: _, ...props} = item;

          return (
            <SBlock key={item.id} data-item-id={item.id}>
              <Component {...props} id={getItemId(id, item.id)} />
            </SBlock>
          );
        }

        const Component = dialogItemsMap[item.type];

        return (
          <SBlock data-item-id={item.id} key={item.id}>
            <Component {...(item as any)} id={getItemId(id, item.id)} />
          </SBlock>
        );
      })}
    </SRoot>
  );
};
